var _style, _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBixColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_Lager_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 503.1 127.6",
    style: {
      enableBackground: "new 0 0 503.1 127.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000023993740742303483850000011884086887066234770_);}\n\t.st1{fill:#B2B2B2;}\n\t.st2{fill:#008DB6;}\n\t.st3{fill:#95C11F;}\n\t.st4{fill:#5488C7;}\n\t.st5{fill:#F39200;}\n\t.st6{fill:#00AAD2;}\n\t.st7{fill:#9F043E;}\n\t.st8{fill:#FFD500;}\n\t.st9{fill:#00528C;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M354.3,127.6c0,0,3.9,0,15.4-14.2l80.4-99.2C457.8,4.6,464.2,0,474.2,0h28.9l-34.4,127.6H354.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140011366535896132300000011267468706483615664_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000140011366535896132300000011267468706483615664_)"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 354.3,
    y: 113.4,
    className: "st1",
    width: 148.8,
    height: 14.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 354.3,
    y: 99.2,
    className: "st2",
    width: 148.8,
    height: 14.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 354.3,
    y: 85,
    className: "st3",
    width: 148.8,
    height: 14.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 354.3,
    y: 70.9,
    className: "st4",
    width: 148.8,
    height: 14.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 354.3,
    y: 56.7,
    className: "st5",
    width: 148.8,
    height: 14.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 354.3,
    y: 42.5,
    className: "st6",
    width: 148.8,
    height: 14.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 354.3,
    y: 28.3,
    className: "st7",
    width: 148.8,
    height: 14.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 354.3,
    y: 14.2,
    className: "st8",
    width: 148.8,
    height: 14.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 354.3,
    y: 0,
    className: "st9",
    width: 148.8,
    height: 14.2
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.3,30.3c-1.3-9.1-7.7-15.1-15.2-15.9c-7.5-0.9-15.6,1.2-24,13.5l-68,99.7h28.1l17-26h45.9l3.1,26h27 L326.3,30.3z M277.1,81.9L303,42.4l4.7,39.4H277.1z M195.6,91.2c21.5-1.5,38.1-15.3,41.6-38.9c3.2-21.6-14.8-38.1-38.9-38.1H144 l-30.6,113.4h26.3L164.1,38h33.5c7.8,0,16.3,7.1,13.8,15.9c-2.2,8-10.5,14.3-17.7,14.3h-21.9c-5.4,0-9.8,4.5-9.8,9.9 c0,1.3,0.3,2.6,0.8,3.7l24.2,45.6h27.4l-19.7-36.3C195.1,91.3,195.3,91.3,195.6,91.2z M100.2,71.1c13.2-5.8,18.9-14.3,19.9-27.4 c1.4-17.6-13.1-29.6-31.2-29.6H30.6L0,127.6h73c16.9,0,34.3-13.4,38.8-29.8C115.2,85,111.2,75.7,100.2,71.1z M82.6,94.2 c-1.8,6.2-8.4,11.2-14.5,11.2H31.9l6.6-23.8H74C80.7,81.6,84.6,87.3,82.6,94.2z M89.9,50.8c-1.8,6.7-7.8,12-13.8,12H43.7l7-25.3 h31.1C88.4,37.5,91.9,43.4,89.9,50.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBixColor);
export default __webpack_public_path__ + "static/media/logoBIXColor.129475dedf9639e43b63a75a90c31894.svg";
export { ForwardRef as ReactComponent };